import React from 'react';

const PastRedemptions = () => {
  return (
    <div>
      <h1>Past Redemptions</h1>
      <p>View your past redemptions here.</p>
      {/* Add list of past redemptions */}
    </div>
  );
};

export default PastRedemptions;